import { render } from "./Print.vue?vue&type=template&id=049f6220&ts=true"
import script from "./Print.vue?vue&type=script&lang=ts"
export * from "./Print.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/james/Desktop/VueJS/ingredient-swap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__